import React from 'react'

export const SideText: React.FC<{text: string, bought: boolean}> = ({text, bought}) => {
  return (
    <div>
      <p className={`text-sm font-light  ${bought ? 'text-gray-300 ' : 'text-[#6F6F6F]'}`} >{text}</p>
    </div>
  )
}
